<div class="version-banner" *ngIf="showBanner">
  <div class="version-banner-content">
    <div class="banner-left">
      <img
        src="assets/svg/ico-bell-red.svg"
        class="bell-icon"
        alt=""
      />
      <div class="message-block">
        <p class="primary-message">
          {{ 'VERSION_BANNER_TITLE' | translate : { version: appVersion } }}
        </p>
        <p class="secondary-message">
          <a class="release-notes-link" (click)="openReleaseNotes()">{{
            'VIEW_RELEASE_NOTES' | translate
          }}</a
          >{{ 'VERSION_BANNER_SUPPORT_HINT' | translate }}
        </p>
      </div>
    </div>
    <button
      type="button"
      class="close-btn"
      (click)="dismissBanner()"
      [disabled]="isDismissing"
      aria-label="Close"
    >
      <img
        src="assets/svg/ico-hamburger-close.svg"
        class="close-icon"
        alt=""
      />
    </button>
  </div>
</div>
